<div *ngIf="isApiCalling" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>
<div id="main">

    <form [formGroup]="jobDetailForm" class="">

        <div *ngIf="isExpressjob && showExpressJobBanner"
            class="alert alert-info py-2 px-2 d-flex flex-column justify-content-between align-items-start my-1 mx-2" role="alert">
            <!-- Left side: bullet points -->
            <ul class="mb-0 pl-3 " style="font-size:12px;">
                <li>Express job is for adding a job which is done instantly.</li>
                <li>You can add jobs which take very less time to complete.</li>
                <li>The job added in express job directly goes to Completed state.</li>
            </ul>
        
            <!-- Right side: link -->
            <div class="d-flex align-items-center justify-content-end w-100">
                <a (click)="hideExpressJobBannerForever()" class=" border rounded p-1 text-dark cursor-pointer"
                    style="cursor: pointer;font-size:12px; color:#0c5460 !important;border-color:#0c5460 !important;">
                    Don't show me again
                    <i class="fa fa-chevron-right ml-1" style="font-size:11px;color:#0c5460 !important;"></i>
                </a>
            </div>
        </div>


        <div *ngIf="!isExpressjob">

            <div class="p-2">
                <div class="d-flex align-items-center justify-content-between py-2 px-0">
                    <div class=""><span class="section-title">Device Details</span></div>
                    <div class="d-flex align-items-center mr-3">
                        <span id="shop" class="mr-2 shop-label">Shop</span>
                        <input class="shop-checkbox" type="checkbox" id="shop" formControlName="Shop">
                    </div>
                </div>

                <div class="divider"></div>

                <div class="device-section py-3">
                    <div class="py-2 px-3 input-container d-flex flex-column" style="row-gap: 16px;">

                        <div *ngIf="jobDetailForm.get('Shop')?.value" class="d-flex flex-column">
                            <label class="field-label" for="shopName">Shop Name*</label>

                            <ng-select placeholder="Select a shop" [items]="shopList" bindValue="BranchID"
                                bindLabel="ShopName" formControlName="ShopName" [searchable]="true" [clearable]="false">
                            </ng-select>

                            <small class="text-danger"
                                *ngIf="jobDetailForm.get('ShopName')?.touched && jobDetailForm.get('ShopName')?.invalid">
                                Shop Name is required.
                            </small>
                        </div>

                        <div class="d-flex flex-column">
                            <label class="field-label" for="deviceType">Device type</label>
                            <!-- <input class="input-field" formControlName="DeviceType" id="deviceType"
                            aria-describedby="deviceType-help" /> -->
                            <ng-select formControlName="DeviceType" id="deviceType" [items]="deviceTypes"
                                bindLabel="DeviceType" bindValue="DeviceType" [addTag]="addDeviceTypeTagFn"
                                [searchable]="true" [clearable]="true" [closeOnSelect]="true" [openOnEnter]="false"
                                [selectOnTab]="false">

                                <ng-template let-search="searchTerm">
                                    <span>Add: "{{search}}"</span>
                                </ng-template>
                            </ng-select>

                        </div>
                        <div class="d-flex flex-column">
                            <label class="field-label" for="brand">Brand</label>
                            <!-- <input class="input-field" formControlName="Brand" id="brand" aria-describedby="brand-help" /> -->
                            <ng-select formControlName="Brand" id="brand" [items]="phoneNames"
                                bindLabel="ManufactureName" bindValue="ManufactureName" [addTag]="addPhoneNamesTagFn"
                                [searchable]="true" [clearable]="true" [closeOnSelect]="true">

                                <ng-template let-search="searchTerm">
                                    <span>Add: "{{search}}"</span>
                                </ng-template>
                            </ng-select>

                        </div>
                        <div class="d-flex flex-column">
                            <label class="field-label" for="modelName">Model name*</label>
                            <!-- <input class="input-field" formControlName="ModelName" id="modelName" /> -->
                            <ng-select formControlName="ModelName" id="modelName" [items]="modelNames"
                                bindLabel="ModelName" bindValue="ModelName" [addTag]="addModelNamesTagFn"
                                [searchable]="true" [clearable]="true" [closeOnSelect]="true">

                                <ng-template let-search="searchTerm">
                                    <span>Add: "{{search}}"</span>
                                </ng-template>
                            </ng-select>
                            <small
                                *ngIf="jobDetailForm.get('ModelName')?.touched && jobDetailForm.get('ModelName')?.invalid"
                                class="text-danger">
                                Model Name is required.
                            </small>
                        </div>
                        <div class="d-flex flex-column">
                            <label class="field-label" for="imei">IMEI No.</label>
                            <input class="input-field" formControlName="Imei" id="imei" aria-describedby="imei-help" />
                        </div>
                        
                        <div class="d-flex flex-column">

                            <div class="d-flex mb-2" style="gap: 0.5rem;">
                                <div (click)="changePatternOrPassword(2)" class="">
                                    <div class="pb-1" [ngStyle]="pass==2 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                                        <label class="field-label mb-0" for="pattern" [ngStyle]="pass==2 ? {'color':'#000'} : {'color':'#888888'}">Password</label>
                                    </div>
                                </div>
                                <div (click)="changePatternOrPassword(1)" class="">
                                    <div class="pb-1" [ngStyle]="pass==1 ? {'border-bottom':'2px outset #000'} : {'color':'#888888'}">
                                        <label class="field-label mb-0" for="pattern" [ngStyle]="pass==1 ? {'color':'#000'} : {'color':'#888888'}">Pattern</label>
                                    </div>
                                </div>
                            </div>
                            <div [ngClass]="{ 'active-tab': pass === 2, 'hidden-tab': pass !== 2 }">
                                <input class="input-field" formControlName="Passcode" id="pattern"
                                    aria-describedby="pattern-help" />
                            </div>
                            <!-- <label class="field-label" for="pattern">Pattern</label> -->
                             <div [formGroup]="jobDetailForm" [ngClass]="{ 'active-tab': pass === 1, 'hidden-tab': pass !== 1 }">
                                 <ngx-pattern-lock refreshButtonLabel="Reset" (patternChange)="onPatternComplete($event)" >
                                 </ngx-pattern-lock>
                             </div>
                        </div>
                        <div class="d-flex flex-column">
                            <label class="field-label" for="issueDescription">Complaint*</label>
                            <textarea class="textarea-field" formControlName="WorkDescription" rows="3" cols="30">
                        </textarea>
                            <small
                                *ngIf="jobDetailForm.get('WorkDescription')?.touched && jobDetailForm.get('WorkDescription')?.invalid"
                                class="text-danger">
                                Complaint is required.
                            </small>
                        </div>
                        <div *ngIf="jobDetailForm.get('accessories')" class="d-flex flex-column" formGroupName="accessories">
                            <label class="field-label" for="remarks">Remarks</label>
                            <textarea class="textarea-field" formControlName="remarks" id="remarks" rows="3" cols="30">
                        </textarea>
                        </div>
                        <div *ngIf="jobDetailForm.get('accessories')" class="input-container d-flex flex-column"
                            formGroupName="accessories">
                            <label class="field-label" for="accessoriesMissing">Accessories Provided</label>
                            <div class="d-flex flex-wrap mt-2" style="gap: 15px;">
                                <div *ngFor="let item of accessoriesConfig.accessoriesProvided" class="checkbox-container">
                                    <input class="custom-checkbox" type="checkbox" id="{{ item.value }}Checkbox"
                                        [formControlName]="item.value">
                                    <label class="checkbox-label mb-0" for="{{ item.value }}Checkbox">{{item.label}}</label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="jobDetailForm.get('accessories')" class="input-container d-flex flex-column"
                            formGroupName="accessories">
                            <label class="field-label" for="accessoriesMissing">Accessories Missing</label>
                            <div class="d-flex flex-wrap mt-2" style="row-gap: 14px; column-gap: 12px;">

                                <div *ngFor="let item of accessoriesConfig.accessoriesMissing" class="checkbox-container">
                                    <input class="custom-checkbox" type="checkbox" id="no{{ item.value }}Checkbox"
                                        [formControlName]="item.value">
                                    <label class="checkbox-label mb-0" for="no{{ item.value }}Checkbox">{{item.label}}</label>
                                </div>
                                
                            </div>
                        </div>

                        <div *ngIf="jobDetailForm.get('accessories')" class="d-flex flex-column" formGroupName="accessories">
                            <label class="field-label" for="deviceColor">Device color</label>
                            <input class="input-field" id="deviceColor" formControlName="color" />
                        </div>

                        <div class="d-flex flex-column">
                            <label class="field-label" for="deliveryDate">To be delivered on*</label>
                            <input class="input-field form-control" type="datetime-local" formControlName="DeliveryDate"
                                id="deliveryDate" style="height: auto;">
                            <small class="text-danger"
                                *ngIf="jobDetailForm.get('DeliveryDate')?.touched && jobDetailForm.get('DeliveryDate')?.invalid">
                                Delivery date is required.
                            </small>
                        </div>
                        <div class="divider"></div>
                        <div class="d-flex flex-column">
                            <label for="assignTo" class="field-label">Assign To</label>

                            <ng-select placeholder="Select a user" [items]="userList" bindValue="UserID"
                                bindLabel="Name" formControlName="AssignTo" [searchable]="true" [clearable]="false">
                            </ng-select>

                        </div>
                    </div>
                </div>
            </div>

            <div class="p-2">
                <div class="px-0"><span class="section-title">Cost</span></div>
                <div class="divider"></div>
                <div class="device-section py-3">
                    <div class="py-2 px-3 d-flex flex-column" style="gap: 16px;">

                        <div *ngIf="!isExpressjob" class="d-flex flex-column">
                            <label class="field-label" for="estimatedCost">Estimated Cost</label>
                            <div class="d-flex align-items-center justify-content-between" style="gap: 8px;">
                                <div>
                                    <input class="input-field" placeholder="Min Cost" id="estimatedCost"
                                        formControlName="MinCost" />
                                </div>

                                <div>
                                    <input class="input-field" placeholder="Max Cost" id="estimatedCost"
                                        formControlName="MaxCost" />
                                </div>
                            </div>
                        </div>

                        <div [class.disabled-section]="!isCostAndPaymentEnabledSeller" class="d-flex flex-column">
                            <label class="field-label" for="advanceCollected">Advance collected</label>
                            <input class="input-field" placeholder="Enter Advance Collected"
                                (click)="openAdvancePaymentModal()" readonly formControlName="AdvanceCollected"
                                id="advanceCollected" />
                        </div>

                    </div>
                </div>
            </div>

            <div *ngIf="!jobDetailForm.get('Shop')?.value" class="p-2">
                <div class="px-0"><span class="section-title">Customer Details</span></div>
                <div class="divider"></div>
                <div class="device-section py-3">
                    <div class="py-2 px-3 d-flex flex-column" style="gap: 16px;">
                        <div class="d-flex flex-column">
                            <label class="field-label" for="deviceColor">Customer Name</label>
                            <input class="input-field" formControlName="ContactPerson" id="customerName" />
                            
                        </div>
                        <div class="d-flex flex-column">
                            <label class="field-label" for="remarks">Customer Number</label>
                            <input class="input-field" formControlName="ContactNo" id="customerNumber" />

                        </div>
                    </div>
                </div>
            </div>

        </div>


        <div *ngIf="isExpressjob">
        
            <div class="p-2">
        
                <div class="device-section py-3">
                    <div class="d-flex align-items-center justify-content-between px-0">
                        <div></div>
                        <div class="d-flex align-items-center mr-3">
                            <span id="shop" class="mr-2 shop-label">Shop</span>
                            <input class="shop-checkbox" type="checkbox" id="shop" formControlName="Shop">
                        </div>
                    </div>
                    <div class="py-2 px-3 input-container d-flex flex-column" style="row-gap: 16px;">
                
                        <div *ngIf="jobDetailForm.get('Shop')?.value" class="d-flex flex-column">
                            <label class="field-label" for="shopName">Shop Name*</label>
                
                            <ng-select placeholder="Select a shop" [items]="shopList" bindValue="BranchID" bindLabel="ShopName"
                                formControlName="ShopName" [searchable]="true" [clearable]="false">
                            </ng-select>
                
                            <small class="text-danger"
                                *ngIf="jobDetailForm.get('ShopName')?.touched && jobDetailForm.get('ShopName')?.invalid">
                                Shop Name is required.
                            </small>
                        </div>
                
                        <div class="d-flex flex-column">
                            <label class="field-label" for="modelName">Model name*</label>
                            <!-- <input class="input-field" formControlName="ModelName" id="modelName" /> -->
                            <ng-select formControlName="ModelName" id="modelName" [items]="modelNames" bindLabel="ModelName"
                                bindValue="ModelName" [addTag]="addModelNamesTagFn" [searchable]="true" [clearable]="true"
                                [closeOnSelect]="true">
                
                                <ng-template let-search="searchTerm">
                                    <span>Add: "{{search}}"</span>
                                </ng-template>
                            </ng-select>
                            <small *ngIf="jobDetailForm.get('ModelName')?.touched && jobDetailForm.get('ModelName')?.invalid"
                                class="text-danger">
                                Model Name is required.
                            </small>
                        </div>
                        <div class="d-flex flex-column">
                            <label class="field-label" for="issueDescription">Complaint*</label>
                            <textarea class="textarea-field" formControlName="WorkDescription" rows="3" cols="30">
                                                </textarea>
                            <small
                                *ngIf="jobDetailForm.get('WorkDescription')?.touched && jobDetailForm.get('WorkDescription')?.invalid"
                                class="text-danger">
                                Complaint is required.
                            </small>
                        </div>
                
                        <!-- <div class="d-flex flex-column">
                            <label class="field-label" for="estimatedCost">Collected Amount</label>
                            <input class="input-field" placeholder="" id="estimatedCost" formControlName="collectedAmount" />
                        </div> -->

                        <div class="d-flex flex-column">
                            <label class="field-label" for="finalCollected">Collected Amount</label>
                            <input class="input-field" placeholder="Enter Collected Amount"
                                (click)="openCollectedAmtPaymentModal()" readonly formControlName="collectedAmount"
                                id="finalCollected" />
                        </div>
                
                        <div *ngIf="!jobDetailForm.get('Shop')?.value" class="py-2 d-flex flex-column" style="gap: 16px;">
                            <div class="d-flex flex-column">
                                <label class="field-label" for="deviceColor">Customer Name</label>
                                <input class="input-field" formControlName="ContactPerson" id="customerName" />
                            </div>
                            <div class="d-flex flex-column">
                                <label class="field-label" for="remarks">Customer Number</label>
                                <input class="input-field" formControlName="ContactNo" id="customerNumber" />
                
                            </div>
                        </div>
                
                
                    </div>
                </div>
            </div>
        
        </div>

        <div class="px-2 py-3 d-flex align-items-center" style="gap: 12px;">
            <button (click)="clearJob()" class="btn clear-btn w-40">Clear</button>
            <button (click)="saveJob()" class="save-btn w-60" [disabled]="jobDetailForm.invalid">Save</button>
        </div>
    </form>
</div>

<div *ngIf="showAdvancePaymentModal" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Advance Payment</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showAdvancePaymentModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="jobDetailForm">
                    <div class="form-group mb-4">
                        <label for="amount">Advance Amount :</label>
                        <input type="number" id="amount" class="form-control" placeholder="Enter Advance Amount (₹)"
                            formControlName="AdvanceCollected" />
                        <small *ngIf="validateAdvanceAmount()" class="text-danger">
                            Advance amount cannot exceed maximum cost.
                        </small>
                    </div>
                    <div class="form-group mb-4 ">
                        <label for="amount">Payment :</label>
                        <button class="btn btn-primary form-control" [disabled]="isAdvanceInvalid"
                            style="background-color:#fff; color:#808080; border-color:#808080;"
                            (click)="openPaymentModesModal('advance')">Select </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showCollectedAmtPaymentModal" class="modal fade show px-1" style="display: block; background: #00000030;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Collected Amount</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="showCollectedAmtPaymentModal = false;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form [formGroup]="jobDetailForm">
                    <div class="form-group mb-4">
                        <label for="amount">Collected Amount :</label>
                        <input type="number" id="amount" class="form-control" placeholder="Enter Collected Amount (₹)"
                            formControlName="collectedAmount" />
                    </div>
                    <div class="form-group mb-4 ">
                        <label for="amount">Payment :</label>
                        <button class="btn btn-primary form-control" [disabled]="!jobDetailForm.get('collectedAmount')?.value"
                            style="background-color:#fff; color:#808080; border-color:#808080;"
                            (click)="openPaymentModesModal('collected-amt')">Select </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-payment-methods *ngIf="showPaymentModesModal" [totalReceivable]="calledFrom ==='advance'? advanceAmountValue: collectedAmountValue "
    [calledFrom]="calledFrom" (close)="handlePaymentModalClose()"
    (paymentSaved)="handlePaymentSaved($event)"></app-payment-methods>